<ng-container *ngTemplateOutlet="tableNutrientTemplate"></ng-container>

<ng-template #tableNutrientTemplate>

  <nz-table #nutrientTable nzSize="small" nzBordered="true" nzOuterBordered="false"
    [nzTotal]="ingredientsCategory.length" [nzPageSize]="0" [nzPageIndex]="0" [nzTemplateMode]="true"
    [nzFrontPagination]="false" [nzScroll]="{ x: this.width, y: this.height}">
    <thead>
      <tr>
        <th rowSpan="2" nzLeft nzWidth="200px">Grupo</th>
        <th nzWidth="80px" rowSpan="2" [nzLeft]="!isDeviceMobile">Cantidad</th>

        <!-- Calories Column -->
        <th colSpan="2">
          <span class="tw-underline cursor-pointer" nz-popover="" [nzPopoverTitle]="'Detalle de Calorías'"
            [nzPopoverContent]="caloriesDetail"
            [ngClass]="this.statusClass[this.getStatus(macronutrientsAdequacy.calories)]">
            Calorías ({{ macronutrientsSummary.calories }}kcal / {{ macronutrientsBase?.calories }}kcal)
          </span>
          <div class="ant-progress-line-container tw-flex">
            <nz-progress style="flex: 1" [nzShowInfo]="false" [nzPercent]="macronutrientsAdequacy.calories * 100"
              [nzStrokeColor]="this.statusColors[this.getStatus(macronutrientsAdequacy.calories)]"></nz-progress>
            <span [ngClass]="this.statusClass[this.getStatus(macronutrientsAdequacy.calories)]" style="flex: 0 0 42px"
              *ngIf="macronutrientsBase">{{ macronutrientsAdequacy.calories | percent:'1.0-0':'en-US' }}</span>
          </div>
        </th>

        <!-- Proteins Column -->
        <th colSpan="2">
          <span class="tw-underline cursor-pointer" nz-popover="" [nzPopoverTitle]="'Detalle de proteínas'"
            [nzPopoverContent]="proteinsDetail" [ngClass]="statusClass[getStatus(macronutrientsAdequacy.proteins)]">
            Proteína ({{ macronutrientsSummary.proteins }}g / {{ macronutrientsBase?.proteins }}g)
          </span>
          <div class="ant-progress-line-container tw-flex">
            <nz-progress style="flex: 1" [nzShowInfo]="false" [nzPercent]="macronutrientsAdequacy.proteins * 100"
              [nzStrokeColor]="statusColors[getStatus(macronutrientsAdequacy.proteins)]"></nz-progress>
            <span [ngClass]="statusClass[getStatus(macronutrientsAdequacy.proteins)]" style="flex: 0 0 42px"
              *ngIf="macronutrientsBase">
              {{ macronutrientsAdequacy.proteins | percent:'1.0-0':'en-US' }}
            </span>
          </div>
        </th>

        <!-- Lipids Column -->
        <th colSpan="2">
          <span class="tw-underline cursor-pointer" nz-popover="" [nzPopoverTitle]="'Detalle de lípidos'"
            [nzPopoverContent]="lipidsDetail" [ngClass]="statusClass[getStatus(macronutrientsAdequacy.lipids)]">
            Lípidos ({{ macronutrientsSummary.lipids }}g / {{ macronutrientsBase?.lipids }}g)
          </span>
          <div class="ant-progress-line-container tw-flex">
            <nz-progress style="flex: 1" [nzShowInfo]="false" [nzPercent]="macronutrientsAdequacy.lipids * 100"
              [nzStrokeColor]="statusColors[getStatus(macronutrientsAdequacy.lipids)]"></nz-progress>
            <span [ngClass]="statusClass[getStatus(macronutrientsAdequacy.lipids)]" style="flex: 0 0 42px"
              *ngIf="macronutrientsBase">
              {{ macronutrientsAdequacy.lipids | percent:'1.0-0':'en-US' }}
            </span>
          </div>
        </th>

        <!-- Carbohydrates Column -->
        <th colSpan="2">
          <span class="tw-underline cursor-pointer" nz-popover="" [nzPopoverTitle]="'Detalle de H.C.'"
            [nzPopoverContent]="carbohydratesDetail"
            [ngClass]="statusClass[getStatus(macronutrientsAdequacy.carbohydrates)]">
            Carbohidratos ({{ macronutrientsSummary.carbohydrates }}g / {{ macronutrientsBase?.carbohydrates }}g)
          </span>
          <div class="ant-progress-line-container tw-flex">
            <nz-progress style="flex: 1" [nzShowInfo]="false" [nzPercent]="macronutrientsAdequacy.carbohydrates * 100"
              [nzStrokeColor]="statusColors[getStatus(macronutrientsAdequacy.carbohydrates)]"></nz-progress>
            <span [ngClass]="statusClass[getStatus(macronutrientsAdequacy.carbohydrates)]" style="flex: 0 0 42px"
              *ngIf="macronutrientsBase">
              {{ macronutrientsAdequacy.carbohydrates | percent:'1.0-0':'en-US' }}
            </span>
          </div>
        </th>


      </tr>

      <tr>
        <th>Porción</th>
        <th>Cantidad </th>
        <th>Porción</th>
        <th>Cantidad</th>
        <th>Porción</th>
        <th>Cantidad</th>
        <th>Porción</th>
        <th>Cantidad</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let category of ingredientsCategory; index as i">
        <tr *ngIf="category.name !== 'Bebidas alcohólicas'" class="category-{{i}}">
          <td nzLeft [ngClass]="{
      'tw-bg-amber-100': this.mapIngredients[category._id] !== 0
      }">{{ category.name }}</td>
          <td [nzLeft]="!isDeviceMobile">
            <nz-input-number (ngModelChange)="this.calcValues(true)" #portion nzSize="small" [nzMin]="0" [nzMax]="100"
              [(ngModel)]="this.mapIngredients[category._id]" [nzDisabled]="disabled"></nz-input-number>
          </td>
          <td>{{ category.smae.calories }} kcal</td>
          <td [ngClass]="{
      'tw-bg-amber-100': this.mapIngredients[category._id] !== 0
      }">{{ category.smae.calories * this.mapIngredients[category._id] }} kcal</td>
          <td>{{ category.smae.proteins }}g</td>
          <td [ngClass]="{
      'tw-bg-amber-100': this.mapIngredients[category._id] !== 0
      }">{{ category.smae.proteins * this.mapIngredients[category._id] }}g</td>
          <td>{{ category.smae.lipids }}g</td>
          <td [ngClass]="{
      'tw-bg-amber-100': this.mapIngredients[category._id] !== 0
      }">{{ category.smae.lipids * this.mapIngredients[category._id] }}g</td>
          <td>{{ category.smae.carbohydrates }}g</td>
          <td [ngClass]="{
      'tw-bg-amber-100': this.mapIngredients[category._id] !== 0
      }">{{ category.smae.carbohydrates * this.mapIngredients[category._id] }}g</td>
        </tr>
      </ng-container>

    </tbody>
  </nz-table>


</ng-template>


<ng-template #caloriesDetail>
  <nz-table nzSize="small" nzBordered="true" nzOuterBordered="false" [nzTemplateMode]="true">
    <tbody>
      <tr>
        <td nzLeft>Calorías Meta</td>
        <td nzLeft>{{this.macronutrientsBase.calories}} kcal</td>
      </tr>
      <tr>
        <td nzLeft>Calorías Totales</td>
        <td nzLeft>{{this.macronutrientsSummary.calories}} kcal</td>
      </tr>
      <tr>
        <td nzLeft>Adecuación</td>
        <td nzLeft>{{this.macronutrientsAdequacy.calories | percent : '1.0-0' : 'en-US' }}</td>
      </tr>

    </tbody>
  </nz-table>
</ng-template>

<ng-template #proteinsDetail>
  <nz-table nzSize="small" nzBordered="true" nzOuterBordered="false" [nzTemplateMode]="true">
    <tbody>
      <tr>
        <td nzLeft>Proteínas Meta</td>
        <td nzLeft>{{this.macronutrientsBase.proteins}}g</td>
      </tr>
      <tr>
        <td nzLeft>Proteínas Totales</td>
        <td nzLeft>{{this.macronutrientsSummary.proteins}}g</td>
      </tr>
      <tr>
        <td nzLeft>Adecuación</td>
        <td nzLeft>{{this.macronutrientsAdequacy.proteins | percent : '1.0-0' : 'en-US' }}</td>
      </tr>

    </tbody>
  </nz-table>
</ng-template>

<ng-template #lipidsDetail>
  <nz-table nzSize="small" nzBordered="true" nzOuterBordered="false" [nzTemplateMode]="true">
    <tbody>
      <tr>
        <td nzLeft>Grasas Meta</td>
        <td nzLeft>{{this.macronutrientsBase.lipids}}g</td>
      </tr>
      <tr>
        <td nzLeft>Grasas Totales</td>
        <td nzLeft>{{this.macronutrientsSummary.lipids}}g</td>
      </tr>
      <tr>
        <td nzLeft>Adecuación</td>
        <td nzLeft>{{this.macronutrientsAdequacy.lipids | percent : '1.0-0' : 'en-US' }}</td>
      </tr>

    </tbody>
  </nz-table>
</ng-template>


<ng-template #carbohydratesDetail>
  <nz-table nzSize="small" nzBordered="true" nzOuterBordered="false" [nzTemplateMode]="true">
    <tbody>
      <tr>
        <td nzLeft>H.C. Meta</td>
        <td nzLeft>{{this.macronutrientsBase.carbohydrates}}g</td>
      </tr>
      <tr>
        <td nzLeft>H.C. Totales</td>
        <td nzLeft>{{this.macronutrientsSummary.carbohydrates}}g</td>
      </tr>
      <tr>
        <td nzLeft>Adecuación</td>
        <td nzLeft>{{this.macronutrientsAdequacy.carbohydrates | percent : '1.0-0' : 'en-US' }}</td>
      </tr>

    </tbody>
  </nz-table>
</ng-template>